import DownloadList from '@/components/downloadList/DownloadList.vue';

export default {
    name: 'Sidebar',
    data () {
        return {
            downloadVisible: false
        }
    },
    props: {
        type: {
            type: String,
            default: 'left',
        },
        open: {
            type: Boolean,
            default: true
        },
        show: {
            type: Boolean,
            default: true
        }
    },
    methods: {
        toggle(isShow) {
            this.$emit('update:open', isShow === true ? isShow : !this.open)

            if (this.open)
                this.$emit('open')
        }
    },
    components: {
        DownloadList
    }
}


// WEBPACK FOOTER //
// ./src/components/sidebar/sidebar.js